


















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    components: { }
})
export default class AnalyticsBlock extends Vue {
    @Prop({required: true}) values: object;
    @Prop({required: true}) title: string;
}
